import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { localize } from 'react-localize-redux';
import { submit, isSubmitting, reduxForm, Field, formValueSelector } from 'redux-form';

import { SelectField, TextField } from 'redux-form-material-ui';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';

let DocumentUploaderForm = class extends Component {
  UNSAFE_componentWillMount() {
    this.setState({ docType: '' });
  }

  documentSelected = (_, docType) => {
    this.props.change('new_document.document_sub_type', null);
    this.props.change('new_document.document_sub_type_name', null);
    this.setState({ docType });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="new_document.file"
          validate={[validator.required]}
          style={{
            border: `1px dashed ${colors.LIGHT_GRAY}`,
            width: '60%',
            margin: 'auto',
            textAlign: 'center',
          }}
          labelText={
            this.props.translate('landlordPortal.documentUploader.clickToAddDocument').props
              .children
          }
          component={ReduxDropzone}
          size={120}
          multiple={false}
        />

        {this._renderDocumentTypeSelectors()}
        {this._renderDocumentTypeTextFieldOnly()}
      </form>
    );
  }

  _renderDocumentTypeTextFieldOnly = () => {
    if (this.props.documentTypes) return;

    return (
      <div className="row" style={{ marginTop: '15px' }}>
        <div className="col-sm-8 col-sm-offset-2">
          <Field
            name="new_document.document_sub_type"
            validate={[validator.required]}
            component={TextField}
            floatingLabelText={
              this.props.translate('landlordPortal.documentUploader.documentName').props.children
            }
            style={{
              marginTop: '-15px',
              fontSize: '14px',
              textAlign: 'left',
              width: '100%',
            }}
          />
        </div>
      </div>
    );
  };

  _renderDocumentTypeSelectors = () => {
    if (!this.props.documentTypes) return;
    return (
      <Fragment>
        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-sm-8 col-sm-offset-2">
            <Field
              name="new_document.document_type"
              validate={[validator.required]}
              component={SelectField}
              onChange={this.documentSelected}
              floatingLabelText={
                this.props.translate('landlordPortal.documentUploader.documentType').props.children
              }
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                textAlign: 'left',
                width: '100%',
              }}
            >
              {Object.keys(this.props.documentTypes).map(docType => (
                <MenuItem value={docType} primaryText={docType} />
              ))}
            </Field>
          </div>
        </div>

        {this.props.showSubTypeTextField === false && (
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2">
              <Field
                name="new_document.document_sub_type"
                validate={[validator.required]}
                component={SelectField}
                disabled={!this.state.docType}
                floatingLabelText={
                  this.props.translate('landlordPortal.documentUploader.document').props.children
                }
                style={{
                  marginTop: '-15px',
                  fontSize: '14px',
                  textAlign: 'left',
                  width: '100%',
                }}
              >
                {(this.props.documentTypes[this.state.docType] || []).map(docName => (
                  <MenuItem value={docName} primaryText={docName} />
                ))}
              </Field>
            </div>
          </div>
        )}

        {this.props.showSubTypeTextField === true && (
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2">
              <Field
                name="new_document.document_sub_type_name"
                validate={[validator.required]}
                component={TextField}
                floatingLabelText={
                  this.props.translate('landlordPortal.documentUploader.documentName').props
                    .children
                }
                style={{
                  marginTop: '-15px',
                  fontSize: '14px',
                  textAlign: 'left',
                  width: '100%',
                }}
              />
            </div>
          </div>
        )}
      </Fragment>
    );
  };
};

const selector = formValueSelector('document_uploader_form');
DocumentUploaderForm = compose(
  connect(store => ({
    showSubTypeTextField: selector(store, 'new_document.document_type') === 'Other',
  })),
  reduxForm({
    form: 'document_uploader_form',
  })
)(localize()(DocumentUploaderForm));

let DocumentUploader = class DocumentUploader extends Component {
  handleSubmit = data => {
    let promiseResponse = this.props.handleSubmit(data);
    if (promiseResponse.then) {
      promiseResponse.then(() => {
        this.props.toggleDialog();
      });
    }
  };

  render() {
    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={this.props.dialogOpen}
        onClose={this.props.toggleDialog}
        aria-labelledby="add-new-document"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="upload-document">
          <h3 style={{ textAlign: 'center', margin: 0 }}>{this.props.translate('addDocument')}</h3>
        </DialogTitle>
        <DialogContent>
          <DocumentUploaderForm
            onSubmit={this.handleSubmit}
            documentTypes={this.props.documentTypes}
          />
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={this.props.toggleDialog}
            id="close-button"
            style={{ color: AccentColor() }}
          >
            {this.props.translate('close')}
          </FlatButton>
          <FlatButton
            onClick={() => this.props.submit('document_uploader_form')}
            disabled={this.props.submitting}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {this.props.translate('add')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
};

export default withMobileDialog()(
  connect(
    state => ({
      submitting: isSubmitting('document_uploader_form')(state),
    }),
    { submit }
  )(localize()(DocumentUploader))
);
